import * as THREE from 'three'

const vertex = `
precision mediump float;

varying mat4 vProjectionMatrix;
varying vec2 vUv;

// ~Light~
// varying vec3 vecPos;
// varying vec3 vecNormal;

${THREE.ShaderChunk.skinning_pars_vertex}

void main()	{
    mat4 modelViewProjectionMatrix = projectionMatrix * modelViewMatrix;

    ${THREE.ShaderChunk.beginnormal_vertex}
    ${THREE.ShaderChunk.skinbase_vertex}
    ${THREE.ShaderChunk.skinnormal_vertex}

    vec3 transformed = vec3( position );

    ${THREE.ShaderChunk.skinning_vertex}

    gl_Position = modelViewProjectionMatrix * vec4(transformed, 1.0);

    vProjectionMatrix = projectionMatrix;
    vUv = uv;

    // Since the light is in camera coordinates,
    // I'll need the vertex position in camera coords too
    // vecPos = (modelViewMatrix * vec4(position, 1.0)).xyz;

    // That's NOT exacly how you should transform your
    // normals but this will work fine, since my model
    // matrix is pretty basic
    // vecNormal = (modelViewMatrix * vec4(normal, 0.0)).xyz;
}
`

export default vertex
